// src/admin/components/SettingsForm.jsx
import React, { useState, useEffect } from "react";
import { adminCreateSettings, adminUpdateSettings } from "../api/admin";
import "./SettingsForm.css";
import { toast } from "react-toastify";

const SettingsForm = ({ settings, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    site_name: "",
    site_url: "",
    platform_fee: 0,
    contact_email: "",
    contact_phone: "",
    address: "",
    social_links: {
      facebook: "",
      twitter: "",
      instagram: "",
      linkdin: "",
      youtube: ""
    }
  });

  useEffect(() => {
    if (settings) {
      setFormData({
        site_name: settings.site_name || "",
        site_url: settings.site_url || "",
        platform_fee: settings.platform_fee || 0,
        contact_email: settings.contact_email || "",
        contact_phone: settings.contact_phone || "",
        address: settings.address || "",
        social_links: {
          facebook: settings.social_links?.facebook || "",
          twitter: settings.social_links?.twitter || "",
          instagram: settings.social_links?.instagram || "",
          linkdin: settings.social_links?.linkdin || "",
          youtube: settings.social_links?.youtube || ""
        }
      });
    }
  }, [settings]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith("social_")) {
      const field = name.replace("social_", "");
      setFormData((prev) => ({
        ...prev,
        social_links: {
          ...prev.social_links,
          [field]: value
        }
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: name === "platform_fee" ? parseFloat(value) || 0 : value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (settings) {
        const settingsId = settings.id || settings._id;
        await adminUpdateSettings(settingsId, formData);
        toast.success("Settings updated successfully! ⚙️");
      } else {
        await adminCreateSettings(formData);
        toast.success("Settings created successfully! ⚙️");
      }
      onSuccess();
    } catch (error) {
      console.error("Error saving settings:", error);
      toast.error(error.response?.data?.detail?.[0]?.msg || 
                  error.response?.data?.message || 
                  "Failed to save settings. ❌");
    }
  };

  return (
    <form className="settings-form" onSubmit={handleSubmit}>
      <div className="form-section">
        <h4>General Info</h4>
        <div className="form-group">
          <label>Site Name</label>
          <input
            type="text"
            name="site_name"
            value={formData.site_name}
            onChange={handleChange}
            placeholder="e.g. Nbitez"
            required
          />
        </div>
        <div className="form-group">
          <label>Site URL</label>
          <input
            type="url"
            name="site_url"
            value={formData.site_url}
            onChange={handleChange}
            placeholder="https://nbitez.com"
            required
          />
        </div>
        <div className="form-group">
          <label>Platform Fee (₹)</label>
          <input
            type="number"
            step="0.01"
            name="platform_fee"
            value={formData.platform_fee}
            onChange={handleChange}
            placeholder="e.g. 5.0"
            required
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Contact Detail</h4>
        <div className="form-group">
          <label>Contact Email</label>
          <input
            type="email"
            name="contact_email"
            value={formData.contact_email}
            onChange={handleChange}
            placeholder="support@nbitez.com"
            required
          />
        </div>
        <div className="form-group">
          <label>Contact Phone</label>
          <input
            type="text"
            name="contact_phone"
            value={formData.contact_phone}
            onChange={handleChange}
            placeholder="+1 234 567 890"
            required
          />
        </div>
        <div className="form-group">
          <label>Address</label>
          <textarea
            name="address"
            rows="3"
            value={formData.address}
            onChange={handleChange}
            placeholder="Nbitez HQ, 123 Street, City"
            required
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Social Links</h4>
        <div className="social-links-grid">
          <div className="form-group">
            <label>Facebook</label>
            <input
              type="url"
              name="social_facebook"
              value={formData.social_links.facebook}
              onChange={handleChange}
              placeholder="https://facebook.com/nbitez"
            />
          </div>
          <div className="form-group">
            <label>Twitter</label>
            <input
              type="url"
              name="social_twitter"
              value={formData.social_links.twitter}
              onChange={handleChange}
              placeholder="https://twitter.com/nbitez"
            />
          </div>
          <div className="form-group">
            <label>Instagram</label>
            <input
              type="url"
              name="social_instagram"
              value={formData.social_links.instagram}
              onChange={handleChange}
              placeholder="https://instagram.com/nbitez"
            />
          </div>
          <div className="form-group">
            <label>LinkedIn</label>
            <input
              type="url"
              name="social_linkdin"
              value={formData.social_links.linkdin}
              onChange={handleChange}
              placeholder="https://linkedin.com/nbitez"
            />
          </div>
          <div className="form-group">
            <label>YouTube</label>
            <input
              type="url"
              name="social_youtube"
              value={formData.social_links.youtube}
              onChange={handleChange}
              placeholder="https://youtube.com/@nbitez"
            />
          </div>
        </div>
      </div>

      <div className="form-actions">
        <button type="submit" className="btn-save">
          {settings ? "Update Settings" : "Save Settings"}
        </button>
        <button type="button" className="btn-cancel" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default SettingsForm;
